import { Pipe, PipeTransform } from '@angular/core';

import _ from 'lodash';
import moment from 'moment-timezone';

import { PurchasingLayerPurchaseHistory } from '../models';
import { Commission } from '../models/commission';

@Pipe({
	name: 'agentCommissions',
	standalone: false,
})
export class AgentCommissionsPipe implements PipeTransform {
	transform(
		commissions: Commission[],
		purchasingLayerPurchaseHistories: PurchasingLayerPurchaseHistory[],
		agentId: string,
		parentId: string,
		brotherId: string,
		commissionViewFilterIndex: boolean,
		commissionViewFilterLayeredPurchasing: boolean,
	): Commission[] {
		return _.orderBy(
			commissions && agentId
				? commissions.filter(c => c.agentId === agentId && moment(c.paidDate).isSameOrBefore(moment(), 'day') && c.paidDate)
				: commissions,
			[
				c => (c.commissionDate ? c.commissionDate.valueOf() : 0),
				c => (c.cycleStartDate ? c.cycleStartDate.valueOf() : 0),
				c => (c.agentId === parentId ? 2 : c.agentId === brotherId ? 3 : 1),
			],
			['asc', 'asc', 'asc'],
		).filter(
			c =>
				c.agentName && // agent name is set if the commission belongs to the agent(s) on the contract
				((commissionViewFilterIndex &&
					!c.purchasingLayerHistoryId &&
					// if contract has no purchasingLayerPurchaseHistories, which means it couldn't be layer purchasing
					(!purchasingLayerPurchaseHistories.length ||
						// or contract has purchasingLayerPurchaseHistories and margin is not equal to lp margin
						(purchasingLayerPurchaseHistories.length && c.margin !== purchasingLayerPurchaseHistories[0].margin))) ||
					(commissionViewFilterLayeredPurchasing &&
						c.purchasingLayerHistoryId &&
						purchasingLayerPurchaseHistories.filter(p => p.id === c.purchasingLayerHistoryId).length &&
						c.margin === purchasingLayerPurchaseHistories.filter(p => p.id === c.purchasingLayerHistoryId)[0].margin)),
		);
	}
}
